import React, { useState } from 'react'
import { Modal } from 'rsuite'
import CheckboxComponent from '../../CommonComponents/CheckboxComponent'
import { Loader } from 'rsuite'

const VendorExportModal = ({ show, onClose, exportData, fileName }) => {
  const [fileExtension, setFileExtension] = useState('csv')

  const handleToggleXLS = (checked) => {
    if (checked) {
      setFileExtension('xls')
    } else {
      setFileExtension('csv')
    }
  }

  const handleToggleCSV = (checked) => {
    if (checked) {
      setFileExtension('csv')
    } else {
      setFileExtension('xls')
    }
  }

  const handleExport = () => {
    let csvContent = ""
    exportData?.forEach((row, index) => {

      const dataString = row.join(',')
      csvContent += index < exportData?.length ? dataString + '\n' : dataString
    })
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const downloadElement = document.createElement('a');
    downloadElement.setAttribute('href', url)
    downloadElement.setAttribute('download', `${fileName || 'supplier'}.${fileExtension}`)
    downloadElement.click()
    onClose(true)
  }

  return (
    <Modal
      backdrop={true}
      className="vendor-export-modal"
      show={show}
      size="lg"
      onClick={() => onClose(false)}
      onHide={() => onClose(false)}
    >
      <Modal.Header>
        <Modal.Title className='fw-bold text-black'>
          Export Results
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`position-relative${exportData?.length === 0 ? ' loading' : ''}`}>
        {exportData?.length === 0 && <Loader style={{ zIndex: 1 }} center={true} size='md' />}
        <div className="header text-black h5 mb-0">
          Exporting to get a better look of your results?
        </div>
        <div className="content pt-5">
          <h4>Choose File Format</h4>
          <CheckboxComponent
            onChange={handleToggleXLS}
            label='XLS (Excel)'
            checked={fileExtension === 'xls'}
          />
          <CheckboxComponent
            label='CSV (comma separated values)'
            onChange={handleToggleCSV}
            checked={fileExtension === 'csv'}
          />
        </div>
        <div className="footer text-black h5 mb-0">
          All {exportData?.length && exportData?.length - 1} items will be exported
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="action-container">
          <button type="button" className="pt-2 pb-2 rounded btn-gray" onClick={() => onClose(false)} disabled={exportData?.length === 0} >
            Cancel
          </button>
          <button type="button" className="pt-2 pb-2 rounded btn-black" onClick={handleExport} disabled={exportData?.length === 0} >
            Export
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
export default VendorExportModal